import styled from "@emotion/styled";
import { FC, useEffect, useMemo } from "react";
import { clsx } from "clsx";
import { useBlocNext } from "@blac/react";
import ConversationListCubit from "../LeapChat/state/ConversationListCubit";
import NotificationsCubit from "src/state/NotificationsCubit/NotificationsCubit";

const Position = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: 0.07rem;
  margin-top: -1rem;
  --size: 1.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;

  .tab-nav & {
    right: 0.8em;
    top: 50%;
    transform: translateY(-60%);
    left: auto;
    margin: 0;
  }

  @media screen and (min-width: 730px) {
    &.nav-badge--home {
      display: none;
    }
  }
`;

const Badge = styled.div`
  min-width: var(--size);
  height: var(--size);
  overflow: hidden;
  padding: 0.25rem;
  border-radius: 2rem;
  text-align: center;
  line-height: calc(var(--size) - 0.7em);
  color: white;
  border: 1px solid var(--nav-badge-border, var(--Greys-Light-Gray, #e6e3db));
  background: var(--nav-badge-bg, var(--Primary-ErrorRed, #bf1902));
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  transition: transform 0.2s cubic-bezier(0.25, 1, 0.5, 1);
  transition-property: transform, color;
  font-weight: 500;

  &[aria-hidden="true"] {
    transform: scale(0);
    color: transparent;
  }
`;

const NavBadge: FC<{
  path: string;
}> = ({ path }) => {
  const [{ conversations }, conversationBloc] = useBlocNext(
    ConversationListCubit
  );
  const [{ unreadCount: notificationUnreadCount }, { loadUnread }] =
    useBlocNext(NotificationsCubit);

  const leapUnreadCount = useMemo(
    () => conversations.reduce((sum, c) => sum + c.unreadMessageCount, 0),
    [conversations]
  );

  const isChat = path === "chat";
  const isHome = path === "home";
  const chatCount = leapUnreadCount;
  const showChat = isChat && chatCount > 0;
  const showHome = isHome && notificationUnreadCount > 0;
  const count = isHome ? notificationUnreadCount : chatCount;
  const show = showChat || showHome;

  useEffect(() => {
    if (isHome) {
      void loadUnread();
    }
    if (isChat) {
      void conversationBloc.refresh();
    }
  }, []);

  return (
    <Position
      className={clsx("nav-badge", {
        "nav-badge--show": show,
        "nav-badge--home": isHome
      })}
    >
      <Badge aria-hidden={!show}>{count < 10 ? count : "9+"}</Badge>
    </Position>
  );
};

export default NavBadge;
